import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { IService } from '../models/service';
import { ServiceService } from '../services/service.service';
import { TimeSpan } from 'src/app/shared/helpers/time-span';

@Injectable({
  providedIn: 'root'
})
export class ServicesResolver  {

  constructor(private serviceService: ServiceService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGridResult<IService[]>> {
    return this.serviceService.searchServices({pageNumber: 0, pageSize: 25})
    .pipe(
      map(response => {

        const data = response.data;

        data.map(x => x.defaultTimeObj = TimeSpan.parse(x.defaultTime))

        return {
          data: data,
          total: response.totalCount
        }
      })
    )
  }
}
